// data.js
import React from 'react';
import GmailSvg from "../../images/integrations_svgs/GmailSvg.svg";
import OutlookSvg from "../../images/integrations_svgs/OutlookSvg.svg";
import GoogleCalenderSvg from "../../images/integrations_svgs/GoogleCalenderSvg.svg";
import OutlookCalenderSvg from "../../images/integrations_svgs/OutlookCalenderSvg.svg";
import ZoomSvg from "../../images/integrations_svgs/ZoomSvg.svg";
import GoogleMeetSvg from "../../images/integrations_svgs/GoogleMeetSvg.svg";
import MicrosoftTeamsSvg from "../../images/integrations_svgs/MicrosoftTeamsSvg.svg";
import FirefliesSvg from "../../images/integrations_svgs/FirefliesSvg.svg";
import CirclebackSvg from "../../images/integrations_svgs/CirclebackSvg.svg";
import OtterSvg from "../../images/integrations_svgs/OtterSvg.svg";
import ReadAiSvg from "../../images/integrations_svgs/ReadAiSvg.svg";
import ClaritySvg from "../../images/integrations_svgs/ClaritySvg.svg";
import GoogleDriveSvg from "../../images/svg/GoogleDriveSvg.svg";
import DropboxSvg from "../../images/svg/DropboxSvg.svg";



const onboardingSteps = [
    {
        step: 1,
        title: "Connect Your Email",
        description: "Sync your email account to enable the platform to pull in important activity and insights.",
        skipped: false,
        options: [
            {
                name: "Gmail",
                icon: GmailSvg,
                status: "connect",
                disabled: false,
                maxHeight: 2.3,
                mrgLeft: 10
            },
            {
                name: "Outlook",
                icon: OutlookSvg,
                status: "coming-soon",
                disabled: true,
                maxHeight: 2.3,
                mrgLeft: 10
            },
        ],
    },
    {
        step: 2,
        title: "Connect Your Calendar",
        description: "Integrate your calendar to automatically sync meeting schedules and reminders.",
        skipped: false,
        options: [
            {
                name: "Google Calendar",
                icon: GoogleCalenderSvg,
                status: "connect",
                disabled: false,
                maxHeight: 2.3,
                mrgLeft: 10
            },
            {
                name: "Outlook Calendar",
                icon: OutlookCalenderSvg,
                status: "coming-soon",
                disabled: true,
                maxHeight: 2.3,
                mrgLeft: 10
            },
        ],
    },
    {
        step: 3,
        title: "Connect Your Meeting Recorder",
        description: "Sync your meeting recorder to automatically pull meeting transcripts into the platform.",
        skipped: false,
        options: [
            {
                name: "Zoom",
                icon: ZoomSvg,
                status: "connect",
                disabled: false,
                mrgLeft: 8,
            },
            {
                name: "Google Meet",
                icon: GoogleMeetSvg,
                status: "connect",
                disabled: false,
                imgMrgLeft: -10
            },
            {
                name: "Microsoft Teams",
                icon: MicrosoftTeamsSvg,
                status: "coming-soon",
                disabled: true,
                imgMrgLeft: -10
            },
            {
                name: "Fireflies",
                icon: FirefliesSvg,
                status: "coming-soon",
                disabled: true,
                imgMrgLeft: -5
            },
            {
                name: "Circleback",
                icon: CirclebackSvg,
                status: "coming-soon",
                disabled: true,
            },
            {
                name: "Otter",
                icon: OtterSvg,
                status: "coming-soon",
                disabled: true,
            },
            {
                name: "Read AI",
                icon: ReadAiSvg,
                status: "coming-soon",
                disabled: true,
                mrgLeft: 10
            },
            {
                name: "Clarity",
                icon: ClaritySvg,
                status: "coming-soon",
                disabled: true,
            },
        ],
    },
    {
        step: 4,
        title: "Connect Your File Storage",
        description: "Link your file storage to keep all your documents and resources organized.",
        skipped: false,
        options: [
            {
                name: "Google Drive",
                icon: GoogleDriveSvg,
                status: "connect",
                disabled: false,
            },
            {
                name: "Dropbox",
                icon: DropboxSvg,
                status: "coming-soon",
                disabled: true,
            },
        ],
    },
    // Add other steps as needed
];


export default onboardingSteps